"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FootballSpecificFact;
(function (FootballSpecificFact) {
    FootballSpecificFact["CORNER"] = "CORNER";
    FootballSpecificFact["GOAL"] = "GOAL";
    FootballSpecificFact["FOUL"] = "FOUL";
    FootballSpecificFact["YELLOW_CARD"] = "YELLOW_CARD";
    FootballSpecificFact["RED_CARD"] = "RED_CARD";
    FootballSpecificFact["FREE_KICK"] = "FREE_KICK";
    FootballSpecificFact["OFFSIDE"] = "OFFSIDE";
    FootballSpecificFact["SHOT_ON_TARGET"] = "SHOT_ON_TARGET";
    FootballSpecificFact["SHOT_OFF_TARGET"] = "SHOT_OFF_TARGET";
    FootballSpecificFact["PENALTY_SHOOTOUT_MISS"] = "PENALTY_SHOOTOUT_MISS";
    FootballSpecificFact["PENALTY_AWARDED"] = "PENALTY_AWARDED";
    FootballSpecificFact["PENALTY_SHOOTOUT_GOAL"] = "PENALTY_SHOOTOUT_GOAL";
    FootballSpecificFact["POSSESSION_CHANGED"] = "POSSESSION_CHANGED";
})(FootballSpecificFact = exports.FootballSpecificFact || (exports.FootballSpecificFact = {}));
exports.footballPlayerFacts = [
    FootballSpecificFact.CORNER,
    FootballSpecificFact.GOAL,
    FootballSpecificFact.FOUL,
    FootballSpecificFact.YELLOW_CARD,
    FootballSpecificFact.RED_CARD,
    FootballSpecificFact.FREE_KICK,
    FootballSpecificFact.OFFSIDE,
    FootballSpecificFact.SHOT_ON_TARGET,
    FootballSpecificFact.SHOT_OFF_TARGET,
    FootballSpecificFact.PENALTY_AWARDED,
    FootballSpecificFact.PENALTY_SHOOTOUT_MISS,
    FootballSpecificFact.PENALTY_SHOOTOUT_GOAL
];
//# sourceMappingURL=Facts.js.map